import { SAPApplicationParameters } from '@platform/client/schemas';
import { RadioGroup } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Leftsection2.svg';

type FormValues = {
  teamSelection: 'team' | 'individual';
};

export const SAPTeamSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<SAPApplicationParameters>();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { teamSelection: getApplicationDataByKey('teamSelection') },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({ teamSelection: data.teamSelection });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      teamSelection: watch('teamSelection'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title='How would you prefer to work on a project?'
        description='
         As part of a cohort, there are two ways you can work on a project. 
        '
      >
        <RadioGroup
          name='sap-team-selection'
          aria-label='sap-team-selection'
          items={[
            {
              value: 'team',
              title: 'Team',
              description: (
                <ul className='list-disc pl-4'>
                  <li>Get matched to a project with 3-4 colleagues with compatible skill sets</li>
                  <li>Each make a contribution to the final deliverable</li>
                  <li>Most volunteers in your program choose this option</li>
                </ul>
              ),
              pillContent: 'Recommended',
            },
            {
              value: 'individual',
              title: 'Individual',
              description: 'I would prefer to be the sole contributor on a project',
            },
          ]}
          alignStart={true}
          pillProps={{
            color: 'blue',
            size: 'md',
            variant: 'plain',
          }}
          onChange={(value) => {
            setValue('teamSelection', value as 'team' | 'individual');
          }}
          register={() => {
            return register('teamSelection', {
              required: 'Select how you prefer to work on a project to continue',
            });
          }}
          defaultValue={getApplicationDataByKey('teamSelection')}
          error={errors.teamSelection?.message}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
